import React, { useContext } from 'react';

import { useRouter } from 'next/router';

import { AppContext } from '../../../context';

import Style from './Header.module.css';

import HeaderInfoMob from './HeaderInfoMob';
import HeaderInfoWeb from './HeaderInfoWeb';
import HeaderSearchMob from './HeaderSearchMob';
import HeaderSearchWeb from './HeaderSearchWeb';
import OptionsUnderJobs from './OptionsUnderJobs';

function Header({ handleSearch }) {
  const { isMobile } = useContext(AppContext);
  const router = useRouter();
  const pathVal = router?.pathname;
  const params = router?.query;

  return (
    <>
      {isMobile ? (
        <>
          {pathVal?.includes('jobs') ? (
            <>
              <HeaderInfoMob />
              <HeaderSearchMob handleSearch={handleSearch} />
              <OptionsUnderJobs isMobile={isMobile} />
            </>
          ) : (
            <>
              <HeaderSearchMob handleSearch={handleSearch} />
              <div>
                {pathVal === '/faqs' ? (
                  <div className={Style.jobOptSelected}>FAQs</div>
                ) : pathVal === '/why-awign' ? (
                  <div className={Style.jobOptSelected}>Why Awign Expert?</div>
                ) : (
                  <div className={Style.jobOptSelected}>My Referrals</div>
                )}
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <>{!params?.slug ? <HeaderInfoWeb /> : null}</>
          <HeaderSearchWeb handleSearch={handleSearch} />
          {pathVal?.includes('jobs') ? <>{!params?.slug ? <OptionsUnderJobs isMobile={isMobile} /> : null}</> : null}
        </>
      )}
    </>
  );
}

export default Header;
